import { useEffect, useRef, useState } from "react";

export default function Cursor() {
  const dot = useRef(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!window.matchMedia("(pointer: fine)").matches) return;
    setEnabled(true);
    const move = (e) => {
      if (!dot.current) return;
      dot.current.style.transform = `translate(${e.clientX}px, ${e.clientY}px) translate(-50%, -50%)`;
    };
    const over = (e) => {
      if (!dot.current) return;
      const t = e.target;
      if (t.closest && t.closest("a,button,[data-cursor-hover]")) dot.current.classList.add("hover");
      else dot.current.classList.remove("hover");
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
    };
  }, []);

  if (!enabled) return null;
  return <div ref={dot} className="ee-cursor-dot" aria-hidden="true" />;
}
